/* eslint-disable ember/no-classic-components */
import Component from "@ember/component";
import { fn } from "@ember/helper";
import { computed, set } from "@ember/object";
import { trustHTML } from "@ember/template";
import { tagName } from "@ember-decorators/component";
import ChooseTopic from "discourse/components/choose-topic";
import CategoryChooser from "discourse/select-kit/components/category-chooser";
import TagChooser from "discourse/select-kit/components/tag-chooser";
import { and } from "discourse/truth-helpers";
import DRadioButton from "discourse/ui-kit/d-radio-button";
import DTextField from "discourse/ui-kit/d-text-field";
import { i18n } from "discourse-i18n";

export const NEW_TOPIC_SELECTION = "new_topic";
export const EXISTING_TOPIC_SELECTION = "existing_topic";
export const NEW_MESSAGE_SELECTION = "new_message";

@tagName("")
export default class ChatToTopicSelector extends Component {
  newTopicSelection = NEW_TOPIC_SELECTION;
  existingTopicSelection = EXISTING_TOPIC_SELECTION;
  newMessageSelection = NEW_MESSAGE_SELECTION;
  selection = null;

  topicTitle = null;
  categoryId = null;
  tags = null;
  selectedTopicId = null;
  chatMessageIds = null;
  chatChannelId = null;

  @computed("site.can_create_tag")
  get canAddTags() {
    return this.site?.can_create_tag;
  }

  set canAddTags(value) {
    set(this, "site.can_create_tag", value);
  }

  @computed("site.can_tag_pms")
  get canTagMessages() {
    return this.site?.can_tag_pms;
  }

  set canTagMessages(value) {
    set(this, "site.can_tag_pms", value);
  }

  @computed("selection")
  get newTopic() {
    return this.selection === NEW_TOPIC_SELECTION;
  }

  @computed("selection")
  get existingTopic() {
    return this.selection === EXISTING_TOPIC_SELECTION;
  }

  @computed("selection")
  get newMessage() {
    return this.selection === NEW_MESSAGE_SELECTION;
  }

  @computed()
  get newTopicInstruction() {
    return trustHTML(this.instructionLabels[NEW_TOPIC_SELECTION]);
  }

  @computed()
  get existingTopicInstruction() {
    return trustHTML(this.instructionLabels[EXISTING_TOPIC_SELECTION]);
  }

  @computed()
  get newMessageInstruction() {
    return trustHTML(this.instructionLabels[NEW_MESSAGE_SELECTION]);
  }

  <template>
    <div class="chat-to-topic-selector" ...attributes>
      <div class="radios">
        <label class="radio-label" for="move-to-new-topic">
          <DRadioButton
            @id="move-to-new-topic"
            @name="move-to-entity"
            @selection={{this.selection}}
            @value={{this.newTopicSelection}}
          />
          <b>{{i18n "topic.split_topic.radio_label"}}</b>
        </label>

        <label class="radio-label" for="move-to-existing-topic">
          <DRadioButton
            @id="move-to-existing-topic"
            @name="move-to-entity"
            @selection={{this.selection}}
            @value={{this.existingTopicSelection}}
          />
          <b>{{i18n "topic.merge_topic.radio_label"}}</b>
        </label>

        {{#if this.allowNewMessage}}
          <label class="radio-label" for="move-to-new-message">
            <DRadioButton
              @id="move-to-new-message"
              @name="move-to-entity"
              @selection={{this.selection}}
              @value={{this.newMessageSelection}}
            />
            <b>{{i18n "topic.move_to_new_message.radio_label"}}</b>
          </label>
        {{/if}}
      </div>

      {{#if this.newTopic}}
        <p>{{this.newTopicInstruction}}</p>

        <form>
          <label for="split-topic-name">
            {{i18n "topic.split_topic.topic_name"}}
          </label>

          <DTextField
            @id="split-topic-name"
            @placeholderKey="composer.title_placeholder"
            @value={{this.topicTitle}}
          />

          <label>{{i18n "categories.category"}}</label>

          <CategoryChooser
            class="small"
            @id="new-topic-category-selector"
            @onChange={{fn (mut this.categoryId)}}
            @value={{this.categoryId}}
          />

          {{#if this.canAddTags}}
            <label>{{i18n "tagging.tags"}}</label>
            <TagChooser
              @categoryId={{this.categoryId}}
              @filterable={{true}}
              @tags={{this.tags}}
            />
          {{/if}}
        </form>
      {{/if}}

      {{#if this.existingTopic}}
        <p>{{this.existingTopicInstruction}}</p>
        <form>
          <ChooseTopic
            @selectedTopicId={{@selectedTopicId}}
            @topicChangedCallback={{@topicChangedCallback}}
          />
        </form>
      {{/if}}

      {{#if (and this.allowNewMessage this.newMessage)}}
        <p>{{this.newMessageInstruction}}</p>

        <form>
          <label for="split-message-title">
            {{i18n "topic.move_to_new_message.message_title"}}
          </label>

          <DTextField
            @id="split-message-title"
            @placeholderKey="composer.title_placeholder"
            @value={{this.topicTitle}}
          />

          {{#if this.canTagMessages}}
            <label>{{i18n "tagging.tags"}}</label>
            <TagChooser @filterable={{true}} @tags={{this.tags}} />
          {{/if}}
        </form>
      {{/if}}
    </div>
  </template>
}
